'use client';
import * as React from 'react';
import { ChatBox } from '@mui/x-chat';
import { createEchoAdapter } from 'docs/data/chat/core/examples/shared/demoUtils';
import { minimalConversation } from 'docs/data/chat/core/examples/shared/demoData';

const adapter = createEchoAdapter();

export default function AutoSubmitSuggestions() {
  return (
    <ChatBox
      adapter={adapter}
      initialActiveConversationId={minimalConversation.id}
      // Seed only the conversation (no messages) so the empty-state suggestions show.
      initialConversations={[minimalConversation]}
      suggestions={['What can you help me with?', 'Tell me a joke']}
      suggestionsAutoSubmit
      sx={{
        height: 500,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
      }}
    />
  );
}
